import { PROJECT_NAVIGATION_CHAT_PDF, PROJECT_NAVIGATION_DOWNLOAD_PDF } from 'state_management/threadedConstants';

/**
 * `true` when the current page is part of a PDF generation flow and must
 * suppress transient app UI (refresh toast, force-refresh dialog, etc.).
 * Three surfaces, three signals:
 *   - Gantt export (Puppeteer-rendered): `?pdfMode=...` query param, set by
 *     `serializeExportRequest` and `fetch_calls.generatePdf`.
 *   - Chat export (Puppeteer-rendered): path `/project/:projectId/chat-pdf`,
 *     built by `components/ChatPdf/api.ts` and rendered by `ChatPdfPage`.
 *   - Server-side PDF download (real user sees it in-browser): path
 *     `/project/:projectId/download/pdf`, rendered by `PDFDownloadPage`. The
 *     user is staring at a "Downloading PDF. Do not close page." screen
 *     while the server generates the file — a refresh prompt here would be
 *     confusing at best and destructive at worst (refresh interrupts).
 *
 * Evaluated once at module load. The value is a constant for the lifetime
 * of the page — these URLs are entered by full navigation (Puppeteer or a
 * server-issued redirect), not SPA route changes.
 *
 * Consumers should import this boolean directly rather than reading
 * `window.location` again — both for consistency and so a single source of
 * truth governs which pages count as PDF-flow pages.
 */
export const isPuppeteerPdfRoute =
  new URLSearchParams(window.location.search).has('pdfMode') || //
  window.location.pathname.endsWith(`/${PROJECT_NAVIGATION_CHAT_PDF}`) || //
  window.location.pathname.endsWith(`/${PROJECT_NAVIGATION_DOWNLOAD_PDF}`);
